window.addEventListener("load", function () {
    function e(e) {
        $(window).width() >= 768 &&
            $(e).length &&
            (gsap.killTweensOf(`${e} .plutope-card, ${e} .master-card, ${e} .elevate-title-wrapper, ${e} .swiper-slide.elev-slide`),
            gsap
                .timeline({ scrollTrigger: { trigger: e, start: "top top", end: "bottom 180%", scrub: !0 } })
                .fromTo(`${e} .plutope-card`, { translateX: "-440%" }, { translateX: "-50%", duration: 2 }, 0)
                .fromTo(`${e} .master-card`, { translateX: "440%" }, { translateX: "50%", duration: 2 }, 0)
                .fromTo(`${e} .elevate-title-wrapper`, { translateY: "250%", opacity: 0 }, { translateY: "-100%", opacity: 1, duration: 1 }, 2)
                .fromTo(`${e} .swiper-slide.elev-slide`, { translateY: "50%", opacity: 0 }, { translateY: "0%", opacity: 1 }));
    }
    function t(e) {
        767 >= $(window).width() &&
            $(e).length &&
            (".section_elevate" === e && window.swiperbio && window.swiperbio.destroy(!0, !0),
            ".section_elevate" === e &&
                (window.swiperbio = new Swiper(".swiper.bio-swiper", {
                    slidesPerView: 2,
                    spaceBetween: 24,
                    pagination: { el: ".swiper-pagination-bio", clickable: !0 },
                    breakpoints: { 320: { slidesPerView: 1, spaceBetween: 10 }, 499: { slidesPerView: 1.5, spaceBetween: 20 }, 768: { slidesPerView: 2, spaceBetween: 20 } },
                })),
            gsap.killTweensOf(`${e} .plutope-card, ${e} .master-card, ${e} .elevate-title-wrapper, ${e} .swiper.bio-swiper`),
            sessionStorage.getItem(`mobileAnimationPlayed-${e}`) ||
                gsap
                    .timeline({
                        scrollTrigger: { trigger: e, start: "top 50%", toggleActions: "play none none none", once: !0 },
                        onComplete: function () {
                            sessionStorage.setItem(`mobileAnimationPlayed-${e}`, "true");
                        },
                    })
                    .fromTo(`${e} .plutope-card`, { translateX: "-200%" }, { translateX: "-50%", duration: 1 }, 0)
                    .fromTo(`${e} .master-card`, { translateX: "200%" }, { translateX: "50%", duration: 1 }, 0)
                    .fromTo(`${e} .elevate-title-wrapper`, { translateY: "50%", opacity: 0 }, { translateY: "0%", opacity: 1, duration: 0.5 })
                    .fromTo(`${e} .swiper.bio-swiper`, { translateY: "50%", opacity: 0 }, { translateY: "0%", opacity: 1 }));
    }
    function i(e, t) {
        let i = e.data("full-text") || e.text();
        e.data("full-text", i);
        let s = Math.floor(i.length * (t / 100)),
            n = i.substring(0, s);
        i.length > s ? e.html(`${n}... <a href="#" class="read-more">Read More</a>`) : e.text(i);
    }
    $("img").each(function () {
        $(this).attr("loading") || $(this).attr("loading", "lazy");
    }),
        // Split words first (synchronously)
        new SplitType("[scrub-each-word]", {
          types: "words",
          tagName: "span",
        });
        
        // GSAP animation per element
        $("[scrub-each-word]").each(function () {
          const $this = $(this);
        
          gsap.set($this.find(".word"), { opacity: 0 }); // Immediately hide all words
        
          gsap.timeline({
            scrollTrigger: {
              trigger: $this,
              start: "top 80%", // Trigger earlier (adjust as needed)
              end: "bottom 50%",
              toggleActions: "play none none none",
            },
          }).to($this.find(".word"), {
            opacity: 1,
            duration: 0.5,
            ease: "power1.out",
            stagger: { each: 0.2 },
          });
        });

        $(window).width() > 767 &&
            new Swiper(".swiper.collections-swiper", {
                slidesPerView: 4,
                spaceBetween: 20,
                navigation: { nextEl: ".arrow.next3", prevEl: ".arrow.prev3" },
                breakpoints: {
                    300: { slidesPerView: 1, spaceBetween: 10 },
                    499: { slidesPerView: 1.5, spaceBetween: 10 },
                    767: { slidesPerView: 2, spaceBetween: 20 },
                    991: { slidesPerView: 3, spaceBetween: 20 },
                    1440: { slidesPerView: 4, spaceBetween: 20 },
                },
            }),
        new Swiper(".swiper.main-swiper", {
            slidesPerView: 1.25,
            spaceBetween: 16,
            pagination: { el: ".swiper-pagination-main", clickable: !0 },
            breakpoints: { 320: { slidesPerView: 1, spaceBetween: 10 }, 768: { slidesPerView: 1.25, spaceBetween: 16 } },
        }),
        $(".image-popup-vertical-fit").magnificPopup({
            type: "image",
            mainClass: "mfp-with-zoom",
            gallery: { enabled: !0 },
            zoom: {
                enabled: !0,
                duration: 300,
                easing: "ease-in-out",
                opener: function (e) {
                    return e.is("img") ? e : e.find("img");
                },
            },
        }),
        $(".div-desc").each(function () {
            i($(this), 35);
        }),
        $(document).on("click", ".read-more", function (e) {
            e.preventDefault();
            let t = $(this).closest(".div-desc"),
                i = t.data("full-text");
            t.html(`${i} <a href="#" class="read-less">Read Less</a>`);
        }),
        $(document).on("click", ".read-less", function (e) {
            e.preventDefault(), i($(this).closest(".div-desc"), 35);
        }),
        gsap.utils.toArray("[gsap-text-anim]").forEach(function (e) {
            var t = new SplitType(e, { type: "lines,words" });
            gsap.timeline({ scrollTrigger: { trigger: e, start: "top 95%", end: "bottom 50%", toggleActions: "play none none none" } }).from(t.words, { duration: 1, opacity: 0, yPercent: 100, ease: "power1.out", stagger: { amount: 0.3 } });
        }),
        gsap.utils.toArray("[fade-in]").forEach(function (e) {
            gsap.timeline({ scrollTrigger: { trigger: e, start: "top 80%", end: "bottom 50%", toggleActions: "play none none none" } }).from(e, { y: 60, opacity: 0, duration: 0.55, ease: "power1.out", stagger: 0.1 });
        }),
        $(".click-block").on("click", function () {
            $(".tab-link-content-wrapper").css("display", "flex");
            var e = this.id;
            $(".tab-link-content").each(function () {
                $(this).attr("dataid") === e ? $(this).css("display", "block") : $(this).css("display", "none");
            });
        }),
        $(".closee-icon").on("click", function () {
            $(".tab-link-content-wrapper").css("display", "none");
        }),
        $(".faq-title-block").click(function () {
            $(".open").not(this).removeClass("open").next().slideUp(300).parent().removeClass("active"), $(this).toggleClass("open").next().slideToggle(300).parent().toggleClass("active");
        }),
        document.body.classList.contains("product-new-template") && (document.querySelector(".normal-div").addEventListener("click", function () {
                document.querySelector(".product-form__submit").click();
            }),
            window.addEventListener("scroll", function () {
                var e = window.scrollY,
                    t = document.documentElement.scrollHeight - window.innerHeight;
                window.innerHeight + e >= document.documentElement.scrollHeight
                    ? document.querySelector(".stc-atc").classList.remove("active")
                    : (e / t) * 100 >= 0
                    ? document.querySelector(".stc-atc").classList.add("active")
                    : document.querySelector(".stc-atc").classList.remove("active");
            })),
        sessionStorage.removeItem("mobileAnimationPlayed-.section_elevates"),
        sessionStorage.removeItem("mobileAnimationPlayed-.section_elevate"),
        e(".section_elevates"),
        e(".section_elevate"),
        t(".section_elevate"),
        $(window).resize(function () {
            e(".section_elevates"), e(".section_elevate"), t(".section_elevate");
        });
}),
    $(window).on("load", function () {
        new Swiper(".swiper.transforamtion-swiper", {
            slidesPerView: 4,
            spaceBetween: 18,
            navigation: { nextEl: ".arrow.next4", prevEl: ".arrow.prev4" },
            breakpoints: {
                320: { slidesPerView: 1.125, spaceBetween: 10 },
                499: { slidesPerView: 1.5, spaceBetween: 10 },
                768: { slidesPerView: 2, spaceBetween: 18 },
                991: { slidesPerView: 2.5, spaceBetween: 18 },
                1179: { slidesPerView: 3, spaceBetween: 18 },
                1460: { slidesPerView: 4, spaceBetween: 18 },
            },
        });
        new Swiper(".swiper.htuswiper-body-wash", {
            slidesPerView: 5,
            spaceBetween: 16,
            pagination: { el: ".swiper-pagination-htu", clickable: !0 },
            breakpoints: {
                320: { slidesPerView: 1, spaceBetween: 10 },
                499: { slidesPerView: 1.5, spaceBetween: 10 },
                768: { slidesPerView: 2, spaceBetween: 16 },
                991: { slidesPerView: 2.5, spaceBetween: 16 },
                1179: { slidesPerView: 3, spaceBetween: 16 },
                1460: { slidesPerView: 5, spaceBetween: 16 },
            },
        }),
            gsap.utils.toArray("[gsap-fade-in]").forEach(function (e) {
                gsap.timeline({ scrollTrigger: { trigger: e, start: "top bottom", end: "bottom top", toggleActions: "play none play none" } }).fromTo(e, { opacity: 0, y: "25%" }, { opacity: 1, y: "0%", duration: 1 });
            }),
            new Swiper(".swiper.celeb-review-swiper", {
                slidesPerView: 5,
                spaceBetween: 16,
                navigation: { nextEl: ".arrow.next", prevEl: ".arrow.prev" },
                breakpoints: {
                    320: { slidesPerView: 1.125, spaceBetween: 10 },
                    400: { slidesPerView: 1.5, spaceBetween: 10 },
                    599: { slidesPerView: 2.5, spaceBetween: 10 },
                    991: { slidesPerView: 3, spaceBetween: 16 },
                    1460: { slidesPerView: 4, spaceBetween: 16 },
                    1800: { slidesPerView: 5, spaceBetween: 16 },
                },
            });
        new Swiper(".swiper.meet_your_heros", {
            slidesPerView: 4,
            spaceBetween: 16,
            navigation: { nextEl: ".arrow.next", prevEl: ".arrow.prev" },
            breakpoints: {
                320: { slidesPerView: 1.125, spaceBetween: 10 },
                400: { slidesPerView: 1.25, spaceBetween: 10 },
                599: { slidesPerView: 1.5, spaceBetween: 10 },
                991: { slidesPerView: 2.5, spaceBetween: 16 },
                1440: { slidesPerView: 3, spaceBetween: 16 },
                1800: { slidesPerView: 4, spaceBetween: 16 },
            },
        });
        $(document).ready(function () {
            $(".variant-block").first().addClass("active"),
                $("body").on("click", ".variant_radio", function () {
                    var e = $(this).data("id");
                    $(".variant-block").each(function () {
                        var t = $(this).data("id");
                        e == t ? $(this).addClass("active") : $(this).removeClass("active");
                    });
                });
        }),
            window.innerWidth <= 991 &&
                new Swiper(".swiper.any-review-swiper", {
                    slidesPerView: 2,
                    spaceBetween: 20,
                    breakpoints: { 320: { slidesPerView: 1.125, spaceBetween: 10 }, 499: { slidesPerView: 1.5, spaceBetween: 10 }, 768: { slidesPerView: 2, spaceBetween: 20 } },
                });
    }),
    $(window).on("load", function () {
        $(window).width() > 767 &&
            new Swiper(".swiper.product-swiper", {
                slidesPerView: 4,
                spaceBetween: 20,
                pagination: { el: ".pro-swiper-pagination", clickable: !0 },
                navigation: { nextEl: ".arrow.next2", prevEl: ".arrow.prev2" },
                breakpoints: {
                    300: { slidesPerView: 1, spaceBetween: 10 },
                    499: { slidesPerView: 1.5, spaceBetween: 10 },
                    767: { slidesPerView: 2, spaceBetween: 20 },
                    991: { slidesPerView: 3, spaceBetween: 20 },
                    1440: { slidesPerView: 4, spaceBetween: 20 },
                },
            });
    }),
    (window.onload = function () {
        const e = document.querySelector(".Tab-section");
        if (!e) return;
        const t = e.querySelectorAll(".title-h3-wrapper"),
            i = e.querySelectorAll(".tab-founder");
        if (1 === t.length) {
            const i = t[0].id;
            t[0].classList.add("active"), e.querySelector(`.tab-founder[data-id="${i}"]`)?.classList.add("active");
        } else if (t.length > 1 && window.innerWidth >= 768) {
            const i = t[0].id;
            t[0].classList.add("active"), e.querySelector(`.tab-founder[data-id="${i}"]`)?.classList.add("active");
        }
        t.forEach((s) => {
            s.addEventListener("click", () => {
                t.forEach((e) => e.classList.remove("active")), i.forEach((e) => e.classList.remove("active")), s.classList.add("active"), e.querySelector(`.tab-founder[data-id="${s.id}"]`)?.classList.add("active");
            });
        }),
            window.innerWidth < 768 &&
                (e.querySelectorAll(".swiper-wrapper").forEach((e) => {
                    const t = e.querySelector(".f-content");
                    if (t) {
                        t.classList.add("open");
                        const e = t.nextElementSibling;
                        e && (e.style.display = "block");
                    }
                }),
                e.querySelectorAll(".f-content").forEach((t) => {
                    t.addEventListener("click", function () {
                        e.querySelectorAll(".f-content.open").forEach((e) => {
                            if (e !== this) {
                                e.classList.remove("open");
                                const t = e.nextElementSibling;
                                t && (t.style.display = "none");
                            }
                        }),
                            this.classList.toggle("open");
                        const t = this.nextElementSibling;
                        t && (t.style.display = "block" === t.style.display ? "none" : "block");
                    });
                }));
        const s = e.querySelectorAll(".button-view"),
            n = e.querySelectorAll(".close-ic"),
            a = e.querySelectorAll(".inside-wrapp-content");
        s.forEach((t) => {
            t.addEventListener("click", () => {
                const i = e.querySelector(`.actual-content[dataid="${t.id}"]`);
                i && (a.forEach((e) => (e.style.display = "none")), (i.closest(".inside-wrapp-content").style.display = "flex"));
            });
        }),
            n.forEach((e) => {
                e.addEventListener("click", () => {
                    const t = e.closest(".inside-wrapp-content");
                    t && (t.style.display = "none");
                });
            });
    });
document.querySelector(".header__icon--cart")?.addEventListener("click", () => {
    setTimeout(() => {
        document.body.classList.remove("overflow-hidden");
    }, 10);
});
window.onload = function () {
    document.querySelectorAll("video.video-banner").forEach((video) => {
        video.play().catch((error) => {
            console.warn("Autoplay failed:", error);
        });
    });
};
function truncateHTMLContent(selector = '.product__description', wordLimit = 23) {
  $(selector).each(function () {
    const $el = $(this);
    if ($el.data('truncated')) return; // Skip already processed elements

    const fullHtml = $el.html().trim();
    if (!fullHtml) return; 

    const $tempDiv = $("<div>").html(fullHtml);
    let wordCount = 0;
    let visibleHtml = '';
    let hiddenHtml = '';
    let isTruncated = false;


    const processNode = (node) => {
      if (wordCount >= wordLimit) {
        hiddenHtml += node.outerHTML || node.textContent || '';
        return;
      }

      if (node.nodeType === 3) { 
        const words = node.textContent.trim().split(/\s+/).filter(w => w);
        if (!words.length) return;

        if (wordCount + words.length <= wordLimit) {
          visibleHtml += node.textContent;
          wordCount += words.length;
        } else {
          const remaining = wordLimit - wordCount;
          visibleHtml += words.slice(0, remaining).join(' ') + ' ';
          hiddenHtml += words.slice(remaining).join(' ') + ' ';
          wordCount = wordLimit;
          isTruncated = true;
        }
      } else if (node.nodeType === 1) { 
        const tag = node.tagName.toLowerCase();
        const attrs = [...node.attributes].map(a => ` ${a.name}="${a.value}"`).join('');
        const openTag = `<${tag}${attrs}>`;
        const closeTag = `</${tag}>`;

        let childVisible = '';
        let childHidden = '';

        $(node).contents().each(function () {
          const prevWordCount = wordCount;
          const prevVisible = visibleHtml;
          const prevHidden = hiddenHtml;
          visibleHtml = '';
          hiddenHtml = '';
          processNode(this);
          childVisible += visibleHtml;
          childHidden += hiddenHtml;
          visibleHtml = prevVisible;
          hiddenHtml = prevHidden;
          wordCount = prevWordCount + (childVisible ? wordsIn(childVisible) : 0);
        });

        if (childVisible) visibleHtml += openTag + childVisible + closeTag;
        if (childHidden) hiddenHtml += openTag + childHidden + closeTag;
      }
    };


    const wordsIn = (str) => str.trim().split(/\s+/).filter(w => w).length;


    $tempDiv.contents().each(function () {
      processNode(this);
    });


    if (isTruncated) {
      $el.html(`
        ${visibleHtml}<span class="dots">...</span>
        <span class="more-text" style="display:none;">${hiddenHtml}</span>
        <a href="#" class="read-more-toggle" style="cursor:pointer;">Read more</a>
      `);
      $el.data('truncated', true);
    }
  });


  $(document).off('click', '.read-more-toggle').on('click', '.read-more-toggle', function (e) {
    e.preventDefault();
    const $el = $(this).closest(selector);
    const $moreText = $el.find('.more-text');
    const $dots = $el.find('.dots');
    const isExpanded = $moreText.is(':visible');

    if (isExpanded) {
      $moreText.hide();
      $dots.show();
      $(this).text('Read more');
    } else {
      $moreText.show();
      $dots.hide();
      $(this).text('Read less');
    }
  });
}

$(document).ready(function () {
  truncateHTMLContent();
});

$(document).on('content-loaded', function () {
  truncateHTMLContent();
});